import React, { useEffect, useState } from 'react';
import SubjectStatusView from '../../ui/SubjectStatusView/SubjectStatusView';
import ExpandedCard from '../../../../components/ExpandedCard/ExpandedCard';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { ReactComponent as TopicFilterIcon } from '../../../../../../resource/TopicFilterIcon.svg';

const SubjectStatusViewCard = () => {
  const [expanded, setExpanded] = useState(false);

  const handleExpanded = () => setExpanded((prev) => !prev);

  const { typeId } = useSelector((state) => state.documentFilterNewStore);

  useEffect(() => {
    if (typeId) {
      setExpanded(true);
      return;
    }

    setExpanded(false);
  }, [typeId]);

  return (
    <Tooltip title={!typeId && 'Укажите тип документа, чтобы открыть фильтры'}>
      <div>
        <ExpandedCard
          expanded={expanded}
          handleExpanded={handleExpanded}
          heading="Тема / вид"
          disabled={!typeId}
          icon={<TopicFilterIcon />}
        >
          <SubjectStatusView />
        </ExpandedCard>
      </div>
    </Tooltip>
  );
};

export default SubjectStatusViewCard;
